import React from 'react';

import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';

import App from './App';
import Globals from './_Globals';
import ErrorBoundary from '@components/ErrorBoundary';
import reportWebVitals from './reportWebVitals';
import store from './store';
import ThemeConfig from './theme';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <ErrorBoundary>
        <Provider store={store}>
          <ThemeConfig>
            <App />
            <Globals />
          </ThemeConfig>
        </Provider>
      </ErrorBoundary>
    </HelmetProvider>
  </React.StrictMode>,
);

reportWebVitals();
